var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { useTranslation } from 'react-i18next';
import { invoice as api } from '../../api';
import { useRequest } from '../../hooks/requestHook';
import { LinearProgress, Alert, Grid } from '@mui/material';
import { useParams } from 'react-router-dom';
import StripeCheckoutForm from './StripeCheckoutForm';
import Button from '../atoms/BaseButton';
import { useInvoice } from '../../hooks/useInvoice';
import { getPublicKey } from './utils';
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 20px 30px;\n"], ["\n  margin: 20px 30px;\n"])));
var StripePayment = function () {
    var _a = useTranslation(), i18n = _a.i18n, t = _a.t;
    var _b = useParams().id, id = _b === void 0 ? '' : _b;
    var navigate = useNavigate();
    var invoice = useInvoice(id).invoice;
    var getStripeClientSecret = useRequest(api.retrieveStripePaymentIntent);
    var _c = React.useState(), clientSecret = _c[0], setClientSecret = _c[1];
    var _d = React.useState(), paymentIntentStatus = _d[0], setPaymentIntentStatus = _d[1];
    var _e = React.useState(true), loading = _e[0], setLoading = _e[1];
    React.useEffect(function () {
        var canceled = false;
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        return [4 /*yield*/, getStripeClientSecret(id)];
                    case 1:
                        response = _a.sent();
                        if (canceled)
                            return [2 /*return*/];
                        setLoading(false);
                        if (!response)
                            return [2 /*return*/];
                        setClientSecret(response.clientSecret);
                        setPaymentIntentStatus(response.status);
                        return [2 /*return*/];
                }
            });
        }); })();
        return function () {
            canceled = true;
        };
    }, [id, getStripeClientSecret]);
    if (loading || !clientSecret || !paymentIntentStatus || !invoice)
        return React.createElement(LinearProgress, null);
    if (paymentIntentStatus === 'succeeded')
        return (React.createElement(Wrapper, null,
            React.createElement(Grid, { item: true, container: true, textAlign: "center", spacing: 3 },
                React.createElement(Grid, { item: true, xs: 12 },
                    React.createElement(Alert, { color: "info" }, t('stripePayment.afterStatusSucceeded'))),
                React.createElement(Grid, { item: true, xs: 12 },
                    React.createElement(Button, { onClick: function () { return navigate("/roaster/invoices/".concat(id)); } }, t('links.back'))))));
    return (React.createElement(Wrapper, null,
        React.createElement(Elements, { stripe: loadStripe(getPublicKey(invoice.roaster)), options: {
                locale: i18n.language,
                clientSecret: clientSecret,
            } },
            React.createElement(StripeCheckoutForm, { invoiceId: id }))));
};
export default StripePayment;
var templateObject_1;
